import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { exam_list, get_questions, submit_certificate_answers } from '../../Apis';


export const GetExamList = createAsyncThunk('GetExamList', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await exam_list(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetQuestions = createAsyncThunk('GetQuestions', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await get_questions(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const SubmitAnswers = createAsyncThunk('SubmitAnswers', async ({ payload, token }, { rejectWithValue }) => {
    try {
        const response = await submit_certificate_answers(payload, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const certificationSlice = createSlice({
    name: 'certificate',
    initialState: {
        error: null,
        success: false,
        data: [],
        questions: {},
    },
    reducers: {
        clearCertificateStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetExamList.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetExamList.fulfilled, (state, action) => {
                state.data = action.payload.data.data;
                state.error = null;
                state.success = action.payload;
            })
            .addCase(GetExamList.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetQuestions.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetQuestions.fulfilled, (state, action) => {
                state.questions = action.payload.data.data;
                state.error = null;
                state.success = action.payload;
            })
            .addCase(GetQuestions.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

    },

});
export const { clearCertificateStatus } = certificationSlice.actions;
export default certificationSlice.reducer;

